import React, { useEffect } from 'react';
import CarouselManagementComponent from '../components/carouselManagement';
import { useDispatch } from 'react-redux';
import { setBlockNavigation } from '../redux/actions/newCourseActions';

function CarouselManagement() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBlockNavigation(false));
  }, []);

  return (
    <div className="page_content">
      <CarouselManagementComponent />
    </div>
  );
}

export default CarouselManagement;
